<template>
  <La1 id="singleSetting" :ratio="'833px 1fr'">
    <L2 slot="left" :style="{paddingInline: '0'}">
      <template slot="filter">
        <div class="title_name">單品</div>
        <Select :defaultValue="area" @input="area=$event" :width="'160px'" :height="'40px'">
          <option :value="null">全部</option>
          <option v-for="(type, t) in restaurants" :key="`s-${t}`" :value="type">{{type}}</option>
        </Select>
        <Select :defaultValue="type" @input="type=$event" :width="'160px'" :height="'40px'">
          <option :value="null">類別</option>
          <option v-for="(type, t) in types" :key="t" :value="type">{{type}}</option>
        </Select>
        <SearchInput :defaultValue="searchText" @input="searchText=$event"/>
        <!-- <RBtn @click="$router.replace({ name: $route.name, query: { page: $route.query.page } })" :text="'新增單點'" :bg="'var(--color-pri)'" :icon="'add'" :style="{paddingInline: '22.5px'}"/> -->
      </template>
      <Table :rows="rows">
        <template slot="slot_head">
          <th :style="{textAlign:'start', width: '10em'}">商品ID</th>
          <th :style="{textAlign:'start', width: 'inherit'}">商品名稱</th>
          <th :style="{textAlign:'start', width: '8em'}">類別</th>
          <th :style="{textAlign:'start', width: '8em'}">餐點用途</th>
          <!-- <th :style="{textAlign:'center', width: '60px'}">貼紙</th> -->
          <th :style="{textAlign:'center', width: '60px'}">刪除</th>
        </template>
        <tr slot-scope="{item: {id, name, name2, erpname, category, type, _id},index}" :id="_id"
        @click="$router.replace({ name: $route.name, query: { page: $route.query.page, id: _id } })"
        :class="itemSelected===_id?'selected':''"
        :style="{height: '65px', border: 'none'}">
          <td :style="{textAlign:'start'}">{{id}}</td>
          <td :style="{textAlign:'start', paddingBlock: '5px'}">{{name}}
            <span v-if="name2" :style="{color:'#CACACA', fontSize:'smaller'}"><br>{{name2}}</span>
            <span v-if="erpname" :style="{color:'#CACACA', fontSize:'smaller', lineHeight: '1em'}"><br>{{erpname}}</span>
          </td>
          <td :style="{textAlign:'start'}">{{category}}</td>
          <td :style="{textAlign:'start'}">{{type}}</td>
        <!-- <td><button class="sticker" @click="updateValue(_id, index, !sticker)">
          <svg v-if="sticker" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M29.9444 0.954807V18.7343H20.5868C19.5545 18.7343 18.7153 19.5707 18.7153 20.6058V29.9635H0.935764C0.418169 29.9635 0 29.5453 0 29.0277V0.954807C0 0.437212 0.418169 0.019043 0.935764 0.019043H29.0087C29.5263 0.019043 29.9444 0.437212 29.9444 0.954807Z" fill="var(--color-pri)"/>
          <path d="M29.7749 20.6058C29.6843 20.8076 29.5556 20.9948 29.3948 21.1556L21.1337 29.4166C20.9729 29.5775 20.7887 29.7032 20.584 29.7968V20.6058H29.7749Z" fill="var(--color-pri)"/>
          </svg>
          <svg v-else width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.954807V29.0277C0 29.5453 0.418169 29.9635 0.935764 29.9635H19.8119C20.309 29.9635 20.7857 29.7676 21.1366 29.4166L29.3976 21.1556C29.7485 20.8047 29.9444 20.328 29.9444 19.8309V0.954807C29.9444 0.437212 29.5263 0.019043 29.0087 0.019043H0.935764C0.418169 0.019043 0 0.437212 0 0.954807ZM20.5868 26.2204V22.4774C20.5868 21.4451 21.4261 20.6058 22.4583 20.6058H26.2014L20.5868 26.2204ZM27.605 18.7343H22.4583C20.3909 18.7343 18.7153 20.4099 18.7153 22.4774V27.6241C18.7153 27.8814 18.5047 28.092 18.2474 28.092H1.9885C1.92416 28.092 1.87153 28.0393 1.87153 27.975V2.00754C1.87153 1.94321 1.92416 1.89057 1.9885 1.89057H27.9559C28.0203 1.89057 28.0729 1.94321 28.0729 2.00754V18.2664C28.0729 18.5238 27.8624 18.7343 27.605 18.7343Z" fill="var(--color-pri)"/>
          </svg>
        </button></td> -->
        <td><DelBtn @click="deleteItem={_id, index, name}" :style="{marginInline: 'auto', transform: 'scale(1)'}"></DelBtn></td>
        </tr>
      </Table>
    </L2>
      <NewCube :types="types" v-if="false" @new="getdata()"/>
      <div v-if="itemSelected===null"></div>
      <ViewCube :types="types" :org="itemS" v-else  @updateMulti="updateMulti" @update="update"  :mode="'single'"/>
      <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="deleteOne(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </La1>
</template>

<script>
import { mapState } from 'vuex'
import ViewCube from './single/view.vue'
import NewCube from './single/new.vue'
import DelBtn from '../../../components/btn/del.vue'
// import RBtn from '../../../components/btn/round.vue'
import Select from '../../../components/select.vue'
import L2 from '../../../components/layout/LaTable.vue'
import La1 from '../../../components/layout/La0.vue'
import Table from '../../../components/tables/t2.vue'
import SearchInput from '../../../components/input/search.vue'
import { getapi, deleteapi, postapi } from '../../../store/fetch'
export default {
  props: ['types'],
  components: {
    L2,
    La1,
    Table,
    Select,
    // RBtn,
    DelBtn,
    ViewCube,
    NewCube,
    SearchInput
  },
  data () {
    return {
      deleteItem: null,
      type: null,
      area: null,
      usage: null,
      searchText: null,
      rows: [],
      subpage: '商品內容'
    }
  },
  computed: {
    ...mapState({
      usages: 'usages',
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    }),
    itemSelected () {
      return this.$route.query.id || null
    },
    itemS () {
      if (this.itemSelected && this.rows.find(e => e._id === this.itemSelected)) {
        return this.rows.find(e => e._id === this.itemSelected)
      } else {
        return null
      }
    }
  },
  async mounted () {
    this.area = this.defaultStore
    await this.getdata()
    if (this.itemSelected) {
      document.getElementById(this.itemSelected).scrollIntoView()
    } else {
      this.itemSelected = this.rows[0]?._id || null
    }
  },
  watch: {
    async area () { await this.getdata() },
    async type () { await this.getdata() },
    async searchText () { await this.getdata() }
  },
  methods: {
    async deleteOne (id, index) {
      await deleteapi(`rest_product/single/${id}`)
      this.rows.splice(index, 1)
      this.deleteItem = null
    },
    async updateValue (id, index, sticker) {
      const r = await postapi(`rest_product/single/${id}`, { sticker })
      console.log(r)
      if (r) {
        this.rows.splice(index, 1, r)
      }
    },

    updateMulti (results) {
      results.map(result => {
        const index = this.rows.map(e => e._id).indexOf(result._id)
        this.rows.splice(index, 1, result)
      })
    },
    update (ev) {
      const index = this.rows.map(e => e._id).indexOf(this.itemSelected)
      console.log('update  ----', index, this.rows[index])
      this.rows.splice(index, 1, ev)
    },
    async getdata () {
      const params = {}
      if (this.type) params.category = this.type
      if (this.area) {
        params.area = this.area
        params.visible = true
      }
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText

      this.rows = await getapi('rest_product/single?' + new URLSearchParams(params))
      console.log(this.rows.length)
    }
  }
}
</script>
<style lang="scss">
#singleSetting {
  padding-inline: 18px 0;
  .La0_right {
    max-height: calc(100vh - 89px)!important;
    border-left: 1px solid #CACACA;
    margin-block: 0;
  }
  .La0_left {
    max-height: calc(100vh - 89px)!important;
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.sticker {
  width: 30px;
  height: 30px;
  background-color: transparent;

}
.title_name {
  font-weight: 500;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-pri);
}
</style>
